<template>
  <div class="relative">
    <!-- Desktop Header -->
    <header class="relative bg-sky-800 h-screen-65 hidden md:block">
      <!-- Achtergrondafbeelding -->
      <div class="absolute inset-0 w-full h-full flex justify-end overflow-hidden">
        <img
          :src="images[currentImage]"
          alt="Gallery Image"
          class="w-3/5 h-full object-cover transition-opacity duration-700 ease-in-out"
        />
        <!-- Overlay alleen over de afbeelding -->
        <div class="absolute top-0 bottom-0 right-0 left-[40%] bg-gradient-to-l from-black/70 to-black/35"></div>
      </div>

      <!-- Tekstgedeelte -->
      <div
        class="absolute inset-0 z-10 flex flex-col items-start justify-center text-left pl-16 lg:pl-32"
      >
        <div class="flex items-start space-x-6">
          <!-- Verticale lijn met vertraagde animatie -->
          <div
            class="w-1 bg-sky-600 h-32 opacity-0 transition-transform duration-700 ease-in-out animation-line-delay"
          ></div>

          <!-- Tekstgedeelte -->
          <div>
            <h1
              class="text-6xl lg:text-6xl xl:text-7xl 2xl:text-7xl font-extrabold text-white ml-8 mb-4 transition-transform duration-700 ease-in-out translate-x-[-100%] opacity-0 animation-slide-in"
            >
              Visspecialist van Wijk
            </h1>
            <p
              class="text-lg lg:text-lg xl:text-xl lg:mr-28 xl:mr-0 text-gray-200 mb-6 ml-8 transition-transform duration-700 delay-300 ease-in-out translate-x-[-100%] opacity-0 animation-slide-in"
            >
              Ontdek onze selectie van verse vis en zeevruchten, rechtstreeks van de beste vissers. Altijd vers, altijd smaakvol.
            </p>
            <a
              href="#assortiment"
              class="px-6 py-3 ml-8 bg-sky-400 text-white font-semibold rounded-md shadow-md hover:bg-sky-500 transition translate-x-[-100%] opacity-0 animation-slide-in delay-600"
            >
              Bekijk ons aanbod
            </a>
          </div>
        </div>
      </div>
    </header>

    <!-- Mobile Header -->
    <header class="relative bg-black h-screen-65 block md:hidden">
      <!-- Achtergrondafbeelding -->
      <div class="absolute inset-0 w-full h-full flex justify-center items-center overflow-hidden">
        <img
          :src="images[currentImage]"
          alt="Gallery Image"
          class="w-full h-full object-cover transition-opacity duration-700 ease-in-out"
        />
        <!-- Overlay -->
        <div class="absolute inset-0 bg-black/50"></div>
      </div>

      <!-- Tekstgedeelte -->
      <div
        class="absolute inset-0 z-10 flex flex-col justify-center items-center text-center p-4"
      >
        <h1
          class="text-4xl font-extrabold text-white mb-4"
        >
          Visspecialist van Wijk
        </h1>
        <p
          class="text-md text-gray-200 mb-6"
        >
          Ontdek onze selectie van verse vis en zeevruchten, rechtstreeks van de beste vissers. Altijd vers, altijd smaakvol.
        </p>
        <a
          href="#"
          class="px-6 py-3 bg-sky-400 text-white font-semibold rounded-md shadow-md hover:bg-sky-500 transition"
        >
          Bekijk ons aanbod
        </a>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: "GalleryHeader",
  data() {
    return {
      images: [
        "/crab.jpg",
        "/oyster.jpg",
        "/salmon.jpg",
        "/shrimp.jpg",
      ],
      currentImage: 0,
      interval: null,
    };
  },
  methods: {
    nextImage() {
      this.currentImage = (this.currentImage + 1) % this.images.length;
    },
  },
  mounted() {
    // Start automatische galerij
    this.interval = setInterval(this.nextImage, 5000); // Elke 5 seconden
  },
  beforeUnmount() {
    // Correcte lifecycle hook voor Vue 3
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
/* Header altijd 65% van de schermhoogte */
.h-screen-65 {
  height: 65vh;
}

/* Animaties voor tekst, knop en lijn */
.animation-slide-in {
  animation: slideIn 1s forwards;
}

.animation-line-delay {
  animation: slideIn 1s 1.2s forwards; /* Start na 1.2 seconden */
}

@keyframes slideIn {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
